<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #e44352;
}
</style>
